import { useEffect } from "react";
import { toast } from "sonner";
import { celebrate, createEggMatcher, EGGS, markEggFound, type EggId } from "@/lib/easterEggs";

/**
 * Wave 11 — Global easter-egg listener. Silent until something hidden is found.
 */
export const EasterEggListener = () => {
  useEffect(() => {
    const reward = (id: EggId) => {
      const definition = EGGS.find((egg) => egg.id === id);
      const isNew = markEggFound(id);
      celebrate(id === "konami" ? 90 : 50);
      toast.success(isNew ? `Easter egg found: ${definition?.name}` : `${definition?.name} again!`, {
        description: isNew ? "Nice. Keep exploring — there are more hidden around." : undefined,
      });
    };

    const matcher = createEggMatcher(reward);

    const onKeyDown = (event: KeyboardEvent) => {
      const target = event.target as HTMLElement | null;
      const tag = target?.tagName;
      if (tag === "INPUT" || tag === "TEXTAREA" || target?.isContentEditable) return;
      matcher(event.key);
    };

    window.addEventListener("keydown", onKeyDown);

    const hour = new Date().getHours();
    if (hour >= 0 && hour < 5) {
      if (markEggFound("midnight")) {
        toast("Night Owl unlocked 🦉", { description: "GenieBot keeps you company after midnight." });
      }
    }

    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);

  return null;
};
